import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "placeholder",
  "use": "placeholder-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"placeholder\"><path fill=\"none\" d=\"M0 0h24v24H0z\" /><path d=\"m12 13.027 6.087 6.6a.637.637 0 0 0 .953 0 .733.733 0 0 0 0-1.027L12.953 12l6.087-6.6a.733.733 0 0 0 0-1.026.64.64 0 0 0-.953 0L12 10.974l-6.087-6.6a.638.638 0 0 0-.953 0 .733.733 0 0 0 0 1.026l6.087 6.6-6.087 6.6a.733.733 0 0 0 0 1.027.638.638 0 0 0 .953 0zM23 1H1v.807h22zm0 21.194H1V23h22z\" /><path d=\"M1.807 23V1H1v22zM23 23V1h-.807v22z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol